/**
 * GMA-1618 (CompassCare Web 3/14) — Vitals route container.
 *
 * Mounts the app-shell (WebShell) around the Vitals triage page (VitalsPage) at
 * /web/vitals, wiring sidebar navigation to the router. This is the route
 * scaffolding: the live-vitals data plumbing (per-client HR/SpO₂/RR/temp +
 * personal baselines from the health-metrics API) is a deliberate follow-up, so
 * until then the page renders its fail-safe empty triage table inside a real,
 * navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import VitalsPage from "./VitalsPage";
import { DEMO_DATA_ENABLED, getDemoClients } from "./demoData";

export default function WebVitalsRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so demo-row generation and the `now` prop agree —
  // staleness / "last update" math drifts if each call reads the clock.
  const now = Date.now();
  // Demo build (commandcenter): seed the triage table so it's fully interactive
  // without the live health-metrics API. Real builds render the empty frame.
  const rows = DEMO_DATA_ENABLED ? getDemoClients(now) : [];
  return (
    <WebShell
      activeKey="vitals"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Vitals"
    >
      <VitalsPage rows={rows} now={now} />
    </WebShell>
  );
}
